module.exports = __webpack_public_path__ + "d768e48c241bcec3c64103daa15a5bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_alpha.png
// module id = 60
// module chunks = 0 1 2 3 4